export default __webpack_public_path__ + "static/media/CMM.70c3e6fd.md";